module.exports = __webpack_public_path__ + "img/20200509_135930.ac82f905.jpg";